module.exports = __webpack_public_path__ + "static/img/4.da49df6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/4.jpg
// module id = oye8
// module chunks = 1